import gql from 'graphql-tag';

export default gql`
  mutation deleteChannelIntegration($id: UUID!) {
    deleteChannelIntegration(_id: $id)
  }
`;
